module.exports = __webpack_public_path__ + "img/delete.81492ad9.png";